<template>
  <div class="detail-main-page">
    <main-header :hasBanner="true"></main-header>
    <section class="main-center list-clr">
      <list-left :type="'resourcesList'"></list-left>
      <div class="page-right">
        <div class="info-top">
          <div class="info-title">房源核验统一编码</div>
          <div class="info-desc">
            {{ obj.code }}
          </div>

          <div>
            <img
              :src="obj.houseqrcodeurl"
              style="width: 140px; margin-left: -7px"
              alt=""
            />
          </div>
        </div>
        <div class="info-bottom">
          <div class="lab-row">
            <div class="lab-item">
              <div class="lab-left">所属城区：</div>
              <div class="lab-right">{{ obj.districtName }}</div>
            </div>
            <div class="lab-item">
              <div class="lab-left">规划用途：</div>
              <div class="lab-right">{{ obj.houseusagename }}</div>
            </div>
          </div>

          <div class="lab-row">
            <div class="lab-item">
              <div class="lab-left">建筑面积：</div>
              <div class="lab-right">{{ obj.architarea }}</div>
            </div>
            <div class="lab-item">
              <div class="lab-left">挂牌时间：</div>
              <div class="lab-right">{{ obj.startDate }}</div>
            </div>
          </div>

          <div class="lab-row">
            <div class="lab-item">
              <div class="lab-left">所在楼层：</div>
              <div class="lab-right">{{ obj.housefloorname }}</div>
            </div>
            <div class="lab-item">
                  <div class="lab-left">小区：</div>
              <div class="lab-right">{{ obj.communityName }}</div>
            </div>
          </div>
        </div>


      <div class="info-bottom">
          <div class="lab-row">
            <div class="lab-item">
              <div class="lab-left">挂牌机构名称：</div>
              <div class="lab-right">{{ obj.communityName }}</div>
            </div>
                <div class="lab-item">
              <div class="lab-left">其他机构牌数：</div>
              <div class="lab-right">{{ obj.otherorganlistingcount }}</div>
            </div>
          
          </div>

           <div class="lab-row">
              <div class="lab-item">
              <div class="lab-left">门店地址：</div>
              <div class="lab-right">{{ obj.address }}</div>
            </div>
         
          </div>

       
        </div>

        <div class="info-bottom">

                <div class="lab-row">
            <div class="lab-item">
              <div class="lab-left">经纪人：</div>
              <div class="lab-right">{{ obj.manager }}</div>
            </div>
         
          </div>
          <div class="lab-row">
            <div class="lab-item">
              <div class="lab-left">经纪人编号：</div>
              <div class="lab-right">{{ obj.agentusercode }}</div>
            </div>
            <div class="lab-item">
              <div class="lab-left">从业时间：</div>
              <div class="lab-right">{{ obj.workinglife }}</div>
            </div>
          </div>

          <div>
            <img
              :src="obj.userqrcodeurl"
              style="width: 140px; margin-left: -7px"
              alt=""
            />
          </div>
        </div>
      </div>
    </section>
    <main-footer></main-footer>
  </div>
</template>

<script>
import vueQr from "vue-qr";
import mainHeader from "@/components/mainHeader";
import mainFooter from "@/components/mainFooter";
import listLeft from "@/components/listLeft";
import { resourcesDetail } from "@/assets/api/resources";
export default {
  name: "App",
  components: {
    mainHeader,
    mainFooter,
    vueQr,
    listLeft,
  },

  data() {
    return {
      tableData: [],
      id: this.$route.query.id,
      goodList: [],
      badList: [],
      obj: "",
      pList: [],
      mbCode: `${this.$globalData.serverUrl}/#/mCompanyDetail?id=${this.$route.query.id}`,
    };
  },
  computed: {},
  mounted() {
    this.getDetail();
  },
  methods: {
    async getDetail() {
      const res = await resourcesDetail({ id: this.id });
      if (res && res.data && res.data.code == 200) {
        this.obj = res.data.data;
        console.log(this.obj);
      }
    },
  },
};
</script>

<style lang="less">
.detail-main-page {
  background: #fff;
  .list-clr {
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    .page-right {
      width: 848px;
      .info-top {
        padding: 20px;
        border: 1px solid #eee;
        line-height: 26px;
        background: url("../../assets/img/info-bg.jpg") no-repeat top right;
        .info-title {
          font-size: 22px;
          font-weight: 700;
          line-height: 36px;
        }
        .info-desc {
          margin-bottom: 14px;
          font-size: 24px;
          color: orange;
          margin-top: 10px;
        }
      }
      .info-bottom {
        line-height: 32px;
        padding: 20px;
        border: 1px solid #eee;
        border-top: none;
      }
      .i-r-t {
        font-size: 16px;
        margin: 20px 0;
      }
      .lab-item {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #555;
        font-size: 14px;
        margin-bottom: 6px;
        .lab-left {
          width: 126px;
          flex-shrink: 0;
        }
        .lab-right {
          flex: 1;
        }
      }
      .lab-row {
        display: flex;
        & > div {
          flex: 1;
        }
      }
    }

    .mg-t20 {
      margin-top: 20px;
    }
    #mapBox {
      width: 100%;
      height: 500px;
    }
  }
  .look-remark {
    color: #fff;
    background-color: #b1191a;
    font-size: 18px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 288px;
    height: 46px;
    cursor: pointer;
  }
}
</style>